import React, { useState } from "react";
import { Edit, Trash2, Plus, ChevronLeft, ChevronRight } from "lucide-react";

export default function TemplatesPage() {
  // Example static data for demo
  const [categoryTemplates] = useState([
    { id: 1, name: "Products on Grid or Lines", viewPath: "CategoryTemplate.ProductsInGridOrLines", order: 1 },
  ]);
  const [manufacturerTemplates] = useState([
    { id: 1, name: "Products on Grid or Lines", viewPath: "ManufacturerTemplate.ProductsInGridOrLines", order: 1 },
  ]);
  const [productTemplates] = useState([
    { id: 1, name: "Simple product", viewPath: "ProductTemplate.Simple", order: 10, productType: "Simple" },
    { id: 2, name: "Grouped product (with variants)", viewPath: "ProductTemplate.Grouped", order: 100, productType: "Grouped" },
  ]);
  const [topicTemplates] = useState([
    { id: 1, name: "Default template", viewPath: "TopicDetails", order: 1 },
  ]);

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <h1 className="text-xl font-semibold text-gray-800 mb-4">Templates</h1>

      <TemplateSection title="Category templates" data={categoryTemplates} />
      <TemplateSection title="Manufacturer templates" data={manufacturerTemplates} />
      <TemplateSection title="Product templates" data={productTemplates} isProduct />
      <TemplateSection title="Topic templates" data={topicTemplates} />
    </div>
  );
}

function TemplateSection({ title, data, isProduct = false }) {
  const [form, setForm] = useState({ name: "", viewPath: "", order: 0 });

  const handleAdd = (e) => {
    e.preventDefault();
    alert(`New template added: ${form.name}`);
  };

  return (
    <div className="bg-white border rounded-lg shadow-sm mb-8">
      <div className="border-b p-3 flex items-center justify-between">
        <h2 className="font-medium text-gray-700 flex items-center gap-2">
          <i className="bi bi-layout-text-sidebar-reverse text-gray-500"></i> {title}
        </h2>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm border-t">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-2 border text-left">Name</th>
              <th className="p-2 border text-left">View path</th>
              <th className="p-2 border text-center">Display order</th>
              {isProduct && <th className="p-2 border text-center">Special product type</th>}
              <th className="p-2 border text-center">Edit</th>
              <th className="p-2 border text-center">Delete</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.id} className="hover:bg-gray-50">
                <td className="p-2 border">{item.name}</td>
                <td className="p-2 border">{item.viewPath}</td>
                <td className="p-2 border text-center">{item.order}</td>
                {isProduct && (
                  <td className="p-2 border text-center text-gray-600">{item.productType}</td>
                )}
                <td className="p-2 border text-center">
                  <button className="bg-gray-100 hover:bg-gray-200 px-3 py-1 rounded-md flex items-center gap-1 mx-auto">
                    <Edit size={14} /> Edit
                  </button>
                </td>
                <td className="p-2 border text-center">
                  <button className="bg-red-100 hover:bg-red-200 px-3 py-1 rounded-md flex items-center gap-1 mx-auto text-red-600">
                    <Trash2 size={14} /> Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col md:flex-row justify-between items-center p-3 gap-2 text-sm">
        <div className="flex items-center gap-2">
          <button className="p-1 border rounded-md hover:bg-gray-100">
            <ChevronLeft size={16} />
          </button>
          <span>1</span>
          <button className="p-1 border rounded-md hover:bg-gray-100">
            <ChevronRight size={16} />
          </button>
          <span className="text-gray-500">of 1</span>
        </div>

        <div className="flex items-center gap-2">
          <span>Show</span>
          <select className="border rounded-md p-1 text-sm">
            <option>15</option>
            <option>25</option>
            <option>50</option>
          </select>
          <span>items</span>
        </div>

        <span className="text-gray-500">1 of {data.length} items</span>
      </div>

      {/* Add Form */}
      <div className="p-4 border-t bg-gray-50">
        <form
          onSubmit={handleAdd}
          className="grid sm:grid-cols-2 md:grid-cols-4 gap-4"
        >
          <div>
            <label className="block text-sm text-gray-600 mb-1">Name</label>
            <input
              type="text"
              className="w-full border rounded-md p-2 text-sm"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">View path</label>
            <input
              type="text"
              className="w-full border rounded-md p-2 text-sm"
              value={form.viewPath}
              onChange={(e) => setForm({ ...form, viewPath: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">Display order</label>
            <input
              type="number"
              className="w-full border rounded-md p-2 text-sm"
              value={form.order}
              onChange={(e) => setForm({ ...form, order: e.target.value })}
            />
          </div>
          <div className="flex items-end">
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md text-sm flex items-center gap-1"
            >
              <Plus size={16} /> Add new record
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
